module.exports = __webpack_public_path__ + "media/src/images/loading-f5ea422c4cd0fa8aea68d4d92a063179.gif";